// @vendors
const React = require('react');
const PropTypes = require('prop-types');

const BrokerExAntItem = require('components/commons/brokerExAntItem/brokerExAntItem');


class BrokerExAntSubSection extends React.Component {
    buildKey(key) {
        const { context } = this.props;
        return `${context}-${key}`
    }

    buildDetails() {
        const {
            section,
            context,
            sectionTitle,
            eventCategory,
            complexTooltip,
        } = this.props;
        if (!!section.get('details')) {
            return section.get('details').map((detail, index) => (
                <BrokerExAntItem
                    data={detail}
                    context={context}
                    key={index}
                    sectionTitle={sectionTitle}
                    eventCategory={eventCategory}
                    complexTooltip={complexTooltip}
                />
            ));
        }
    }

    render() {
        const {
            section,
            context,
            sectionTitle,
            eventCategory,
            complexTooltip,
        } = this.props;
        return (
            <div>
                <BrokerExAntItem
                    data={section}
                    context={context}
                    sectionTitle={sectionTitle}
                    eventCategory={eventCategory}
                    complexTooltip={complexTooltip}
                />
                <div className="broker-ex-ant-cost__subsection-details">
                    {this.buildDetails()}
                </div>
            </div>
        );
    }
}

BrokerExAntSubSection.propTypes = {
    section: PropTypes.object,
    context: PropTypes.string,
    sectionTitle: PropTypes.string,
    eventCategory: PropTypes.string,
    complexTooltip: PropTypes.bool,
}


module.exports = BrokerExAntSubSection;
